import { render, staticRenderFns } from "./crmProjectManagement.vue?vue&type=template&id=9cb0d1fa&scoped=true&"
import script from "./crmProjectManagement.vue?vue&type=script&lang=js&"
export * from "./crmProjectManagement.vue?vue&type=script&lang=js&"
import style0 from "./crmProjectManagement.vue?vue&type=style&index=0&id=9cb0d1fa&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cb0d1fa",
  null
  
)

export default component.exports